var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9113 8.1896C13.7732 7.96761 13.497 7.83407 13.1658 7.83407L8.91136 7.83493L10.2644 0.77547C10.3194 0.465041 10.0982 0.153724 9.74003 0.0427299C9.38072 -0.0682644 8.96638 0.0427299 8.74518 0.308939L0.128373 11.1422C-0.037792 11.3417 -0.0377917 11.6087 0.10032 11.8307C0.238432 12.0527 0.514656 12.1863 0.818944 12.1863H4.99048L2.64257 19.1563C2.53252 19.4667 2.72566 19.7997 3.08498 19.9332C3.19503 19.9775 3.33315 20 3.44429 20C3.69246 20 3.96867 19.9116 4.10678 19.7338L13.8567 8.8781C14.0217 8.67865 14.0498 8.41157 13.9117 8.18958L13.9113 8.1896ZM5.43154 15.9819L6.86768 11.6757C6.92271 11.4763 6.89574 11.2543 6.72957 11.0982C6.56341 10.943 6.3433 10.832 6.06708 10.832H2.33805L8.02882 3.68416L7.11706 8.3901C7.08901 8.58955 7.14511 8.76731 7.3102 8.92252C7.47637 9.07774 7.69647 9.14451 7.94574 9.14451H11.5648L5.43154 15.9819Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.e9f2bec10376b8465b2c1ad7ff97736f.svg";
export { ForwardRef as ReactComponent };